"use client";
import React, { createContext, useContext, useState, useEffect } from 'react';

// สร้าง Context สำหรับ Mouse Movement
const MouseMovementContext = createContext({ hasMouseMoved: false });

import { ReactNode } from 'react';

export const MouseMovementProvider = ({ children }: { children: ReactNode }) => {
    const [hasMouseMoved, setHasMouseMoved] = useState(false);

    useEffect(() => {
        const handleMouseMove = () => {
            setHasMouseMoved(true);
        };
        
        window.addEventListener("mousemove", handleMouseMove);
        window.addEventListener("touchmove", handleMouseMove);
        window.addEventListener("scroll", handleMouseMove);

        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("touchmove", handleMouseMove);
            window.removeEventListener("scroll", handleMouseMove);
        };
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => {
            setHasMouseMoved(true);
        }, 5000);

        return () => {
            clearTimeout(timer);
        };
    }, []);

    return (
        <MouseMovementContext.Provider value={{ hasMouseMoved }}>
            {children}
        </MouseMovementContext.Provider>
    );
};

// Custom Hook สำหรับใช้งาน MouseMovementContext
export const useMouseMovement = () => {
    return useContext(MouseMovementContext);
};
